enum Hemisphere {
  N = "N",
  S = "S",
  E = "E",
  W = "W",
}

export default Hemisphere;